module.exports = __webpack_public_path__ + "img/7.42bf545e.jpg";